<template>
  <GeneralSelectionComponent/>
</template>

<script>
import GeneralSelectionComponent from '../GeneralSelectionComponent.vue'
export default {
  name: "CampaignSelectionStep.vue",
  components: {
    GeneralSelectionComponent,
  },
};
</script>

<style scoped>

</style>
